import * as React from 'react';

import type { UseToggletipReturn } from './useToggletip.types';

export function useToggletip(): UseToggletipReturn {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClose = React.useCallback((): void => {
    setAnchorEl(null);
  }, []);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>): void => {
      if (anchorEl) {
        handleClose();
      } else {
        setAnchorEl(event.currentTarget);
      }
    },
    [anchorEl, handleClose]
  );

  return { anchorEl, handleClick, handleClose };
}
